var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReview = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#48B288",
  d: "M20.4 4.4H3.6A1.6 1.6 0 0 0 2 6v12.065a1.6 1.6 0 0 0 1.6 1.6h5.704a.8.8 0 0 1 .562.23l1.573 1.551a.8.8 0 0 0 1.123 0l1.574-1.55a.8.8 0 0 1 .561-.23h5.704a1.6 1.6 0 0 0 1.6-1.6V6a1.6 1.6 0 0 0-1.6-1.6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF4BE",
  d: "M11.68 6.965a.384.384 0 0 1 .64 0l1.554 2.34a.38.38 0 0 0 .223.16l2.74.72c.27.072.377.4.198.617l-1.776 2.152a.38.38 0 0 0-.088.264l.146 2.772a.384.384 0 0 1-.518.38l-2.663-1a.38.38 0 0 0-.27 0l-2.664 1a.384.384 0 0 1-.518-.38l.146-2.772a.38.38 0 0 0-.088-.264l-1.776-2.152a.384.384 0 0 1 .198-.616l2.74-.722a.38.38 0 0 0 .223-.159l1.554-2.34Z"
})));
export default SvgReview;